import { combineReducers } from "redux";

const generateTextPoster = (state = {}, action) => {
    switch (action.type) {
        case "GENERATE_TEXT_POSTER_SUCCESS":
            return {
                isLoading: false,
                isError: false,
                isSuccess: true,
                generatedImage: action.payload.image,
                uuid: action.payload.uuid,
            };
        case "CLEAR_GENERATED_TEXT_POSTER":
            return {};
        default:
            return state;
    }
};

const fetchUserTextPosters = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_USER_TEXT_POSTERS_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchTextPosters: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchTextPosters: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

const fetchSearchPosters = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_SEARCH_TEXT_POSTERS_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchPosters: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchPosters: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

export default combineReducers({
    generateTextPoster,
    fetchUserTextPosters,
    fetchSearchPosters,
});
